import { LayoutGrid } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useGetApiCompaniesCurrentEmployeesReportingActivemodules } from '@/api/generated/company-management-user/company-management-user'
import { StatisticsCard } from '../components/StatisticsCard'

export function ActiveModulesCard() {
  const { t } = useTranslation('dashboard')
  const { data, isLoading, isError } = useGetApiCompaniesCurrentEmployeesReportingActivemodules()

  return (
    <StatisticsCard
      title={t('statistics.activeModules.title')}
      value={data?.data?.count ?? '—'}
      sub={t('statistics.activeModules.sub')}
      CustomIcon={LayoutGrid}
      isLoading={isLoading}
      isError={isError}
    />
  )
}
